import React, { useEffect, useState } from 'react'
import Navigation from './navigation/navigation'
import { HoldCoPage } from './HoldCoPage'


/**
 * HoldCoPage
 * @renders UserContainer*
 * @maps db.users with userCard 
 * @returns 
 */
export function Admin() {
  const [loading, setLoading] = useState(false)
  const [header, setHeader] = useState('PITX')
  const handleLogout = () => {
    localStorage.removeItem('jwt')
    localStorage.removeItem('userFirstName')
    localStorage.removeItem('userLastName')
    localStorage.removeItem('userEmail')
    localStorage.removeItem('token')
    window.location.reload()
  }
  const renderData = data => {
    if (data === 'PITX') {
      return <HoldCoPage />
    } else {
      return <div>Under development on phase 2</div>
    }
  }
  return (
    <>
      <Navigation
        appBarHeader={header}
        handleLogout={handleLogout}
        clicked={header => setHeader(header)}
      >
        {renderData(header)}
      </Navigation>
    </>
  )
}
